<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :size="size"
        v-bind="attrs"
        v-on="on"
        class="mx-1 mb-1"
      >
        mdi-information-outline
      </v-icon>
    </template>
    <span v-html="text"/>
  </v-tooltip>
</template>

<script>
export default {
  name: 'InfoTooltip',
  props: {
    text: String,
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {}
  }
}
</script>
